import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors } from "style";
import PrimaryLink from "./Primary";

/**
 * SecondaryLink
 *
 * @param {node} children
 */
const SecondaryLink = ({ children, ...props }) => (
  <PrimaryLink css={styles.link} {...props}>
    {children}
  </PrimaryLink>
);

const styles = {
  link: css`
    color: ${colors.grayAnatomyDark};
    font-weight: 500;

    .link-text::after {
      border-bottom-color: ${colors.grayAnatomyLight1};
    }
  `,
};

SecondaryLink.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SecondaryLink;
